import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { services } from '../pages/Sell/services';
import SingleDayDialog from './single-day-dialog';

const SalesAndBuyback = ({ trigger, totalTodaysSell }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [buybackInfo, setBuybackInfo] = useState();
  const [data, setData] = React.useState([]);
  const [currentDateStr, setCurrentDateStr] = useState('امروز'); // <-- متن تاریخ جاری
  const [isCustomDate, setIsCustomDate] = useState(false); // <-- مشخص کردن تاریخ انتخابی

  const todaysStats = React.useMemo(() => {
    const overall = {
      transactionsCount: 0,
      bullion1g: 0,
      bullion2g: 0,
      bullion5g: 0,
      bullion10g: 0,
      bullion20g: 0,
      bullion50g: 0,
      bullion100g: 0,
    };

    const branchesMap = {};

    data?.forEach(row => {
      const branch = row.branch || 'نامشخص';
      const items = row.items || [];

      if (!branchesMap[branch]) {
        branchesMap[branch] = {
          branch: branch,
          transactionsCount: 0,
          bullion1g: 0,
          bullion2g: 0,
          bullion5g: 0,
          bullion10g: 0,
          bullion20g: 0,
          bullion50g: 0,
          bullion100g: 0,
        };
      }

      const b1 = Number(items.find(i => i.type === 'GB_999_1')?.count || 0);
      const b2 = Number(items.find(i => i.type === 'GB_999_2')?.count || 0);
      const b5 = Number(items.find(i => i.type === 'GB_999_5')?.count || 0);
      const b10 = Number(items.find(i => i.type === 'GB_999_10')?.count || 0);
      const b20 = Number(items.find(i => i.type === 'GB_999_20')?.count || 0);
      const b50 = Number(items.find(i => i.type === 'GB_999_50')?.count || 0);
      const b100 = Number(items.find(i => i.type === 'GB_999_100')?.count || 0);

      branchesMap[branch].transactionsCount += 1;
      branchesMap[branch].bullion1g += b1;
      branchesMap[branch].bullion2g += b2;
      branchesMap[branch].bullion5g += b5;
      branchesMap[branch].bullion10g += b10;
      branchesMap[branch].bullion20g += b20;
      branchesMap[branch].bullion50g += b50;
      branchesMap[branch].bullion100g += b100;

      overall.transactionsCount += 1;
      overall.bullion1g += b1;
      overall.bullion2g += b2;
      overall.bullion5g += b5;
      overall.bullion10g += b10;
      overall.bullion20g += b20;
      overall.bullion50g += b50;
      overall.bullion100g += b100;
    });

    return {
      overall,
      byBranch: Object.values(branchesMap),
    };
  }, [data]);

  console.log('the all new data is:', todaysStats);

  // دریافت اطلاعات با تاریخ مشخص یا پیش‌فرض
  const fetchData = async selectedDate => {
    try {
      let params = {};
      if (selectedDate) {
        const year = selectedDate.getFullYear();
        const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
        const day = String(selectedDate.getDate()).padStart(2, '0');
        params.gregorianDate = `${year}-${month}-${day}`;

        // ذخیره عنوان تاریخ شمسی
        setCurrentDateStr(
          new Intl.DateTimeFormat('fa-IR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }).format(selectedDate)
        );
        setIsCustomDate(true);
      } else {
        setCurrentDateStr('امروز');
        setIsCustomDate(false);
      }

      const response = await services.getTransactionsByDate(params);
      setData(response);
    } catch (error) {
      console.error('Failed to fetch invoices:', error);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, [trigger]);

  useEffect(() => {
    services.getTodayBuyback().then(res => {
      setBuybackInfo(res);
    });
  }, [trigger]);

  // استخراج امن اطلاعات کل و تفکیک شعب از State
  const activeStats = data?.length > 0 ? todaysStats : totalTodaysSell;
  const overallSell = activeStats?.overall || {
    bullion1g: 0,
    bullion2g: 0,
    bullion5g: 0,
    bullion10g: 0,
    bullion20g: 0,
    bullion50g: 0,
    bullion100g: 0,
  };
  const branchesSell = activeStats?.byBranch || [];

  // آرایه rows (جهت خروجی گرفتن در صورت نیاز)
  const rows = [
    {
      label: 'تعداد کل فروش',
      bullion1g: Number(overallSell.bullion1g).toLocaleString('fa-IR') + ' عدد',
      bullion2g: Number(overallSell.bullion2g).toLocaleString('fa-IR') + ' عدد',
      bullion5g: Number(overallSell.bullion5g).toLocaleString('fa-IR') + ' عدد',
      bullion10g:
        Number(overallSell.bullion10g).toLocaleString('fa-IR') + ' عدد',
      bullion20g:
        Number(overallSell.bullion20g).toLocaleString('fa-IR') + ' عدد',
      bullion50g:
        Number(overallSell.bullion50g).toLocaleString('fa-IR') + ' عدد',
      bullion100g:
        Number(overallSell.bullion100g).toLocaleString('fa-IR') + ' عدد',
      total:
        Number(
          overallSell.bullion1g * 1 +
            overallSell.bullion2g * 2 +
            overallSell.bullion5g * 5 +
            overallSell.bullion10g * 10 +
            overallSell.bullion20g * 20 +
            overallSell.bullion50g * 50 +
            overallSell.bullion100g * 100
        ).toLocaleString('fa-IR') + ' گرم',
    },
  ];

  return (
    <Grid
      item
      pt={'0px !important'}
      xs={12}
      md={6}
      sx={{ mb: { xs: 2, sm: 2, md: 0 } }}
    >
      <Box
        sx={{
          background: 'rgba(255, 255, 255, 0.2)',
          borderRadius: { xs: '12px', sm: '14px', md: '16px' },
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(8px) saturate(180%)',
          p: { xs: 2, sm: 2.5, md: 3 },
          transition: 'box-shadow 0.3s ease',
          '&:hover': {
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
          },
          minWidth: 'auto',
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 2 }}
        >
          {/* نمایش عنوان همراه با تاریخ انتخابی */}
          <Typography
            variant={{ xs: 'h6', sm: 'h6', md: 'h5' }}
            sx={{
              fontWeight: 700,
              color: '#111827',
              letterSpacing: '0.5px',
            }}
          >
            {isCustomDate ? 'فروش' : 'فروش و بازخرید'}
            <Typography
              component="span"
              variant="body2"
              sx={{ ml: 1, color: '#2563eb', fontWeight: 'bold' }}
            >
              ({currentDateStr})
            </Typography>
          </Typography>

          <Stack direction="row" spacing={1}>
            {/* دکمه بازگشت به امروز (فقط زمانی که تاریخ انتخاب شده نمایش داده می‌شود) */}
            {isCustomDate && (
              <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={() => fetchData()}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 2,
                  py: 0.8,
                }}
              >
                بازگشت به امروز
              </Button>
            )}

            {/* دکمه باز کردن مدال */}
            <Button
              variant="contained"
              size="small"
              onClick={() => setIsDialogOpen(true)}
              sx={{
                backgroundColor: '#2563eb',
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                px: 2.5,
                py: 0.8,
                '&:hover': { backgroundColor: '#1d4ed8' },
              }}
            >
              فروش در تاریخ خاص
            </Button>
          </Stack>
        </Stack>
        <TableContainer
          component={Paper}
          sx={{
            mt: 2,
            borderRadius: '12px',
            border: 'none',
            boxShadow: 'none',
            background: 'transparent',
            overflowX: { xs: 'auto', sm: 'auto' },
            WebkitOverflowScrolling: 'touch',
            minWidth: 'auto',
          }}
        >
          <Table aria-label="today's sales table">
            <TableHead>
              <TableRow
                sx={{
                  background: 'linear-gradient(45deg, #2563eb, #1d4ed8)',
                  borderRadius: '12px 12px 0 0',
                  '& th': {
                    fontWeight: 700,
                    color: '#fff',
                    py: { xs: 1.5, sm: 1.5, md: 2 },
                    px: { xs: 1, sm: 1.5, md: 2 },
                    fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.85rem' },
                    borderBottom: 'none',
                    whiteSpace: 'nowrap',
                  },
                }}
              >
                <TableCell></TableCell>
                <TableCell>۱g</TableCell>
                <TableCell>۲g</TableCell>
                <TableCell>۵g</TableCell>
                <TableCell>۱۰g</TableCell>
                <TableCell>۲۰g</TableCell>
                <TableCell>۵۰g</TableCell>
                <TableCell>۱۰۰g</TableCell>
                <TableCell
                  sx={{
                    whiteSpace: { xs: 'nowrap', sm: 'normal', md: 'normal' },
                  }}
                >
                  مجموع وزن
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* --- ردیف فروش کل --- */}
              <TableRow
                sx={{
                  background: 'rgba(255, 255, 255, 0.9)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    background: 'rgba(191, 219, 254, 0.7)',
                  },
                  '& td': {
                    color: '#111827',
                    borderBottom: 'none',
                    fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.85rem' },
                    py: { xs: 1.2, sm: 1.5, md: 1.8 },
                    px: { xs: 1, sm: 1.5, md: 2 },
                    fontWeight: 700,
                    whiteSpace: { xs: 'nowrap', sm: 'nowrap', md: 'normal' },
                  },
                }}
              >
                <TableCell>فروش کل</TableCell>
                <TableCell>
                  {Number(overallSell.bullion1g).toLocaleString('fa-IR')}
                </TableCell>
                <TableCell>
                  {Number(overallSell.bullion2g).toLocaleString('fa-IR')}
                </TableCell>
                <TableCell>
                  {Number(overallSell.bullion5g).toLocaleString('fa-IR')}
                </TableCell>
                <TableCell>
                  {Number(overallSell.bullion10g).toLocaleString('fa-IR')}
                </TableCell>
                <TableCell>
                  {Number(overallSell.bullion20g).toLocaleString('fa-IR')}
                </TableCell>
                <TableCell>
                  {Number(overallSell.bullion50g).toLocaleString('fa-IR')}
                </TableCell>
                <TableCell>
                  {Number(overallSell.bullion100g).toLocaleString('fa-IR')}
                </TableCell>
                <TableCell sx={{ color: '#2563eb !important' }}>
                  {Number(
                    overallSell.bullion1g * 1 +
                      overallSell.bullion2g * 2 +
                      overallSell.bullion5g * 5 +
                      overallSell.bullion10g * 10 +
                      overallSell.bullion20g * 20 +
                      overallSell.bullion50g * 50 +
                      overallSell.bullion100g * 100
                  ).toLocaleString('fa-IR')}{' '}
                  <Typography variant="caption" sx={{ fontWeight: 'normal' }}>
                    {' '}
                    گرم
                  </Typography>
                </TableCell>
              </TableRow>

              {/* --- ردیف‌های تفکیک شعب برای فروش --- */}
              {branchesSell.map((branchStats, idx) => (
                <TableRow
                  key={idx}
                  sx={{
                    background: 'rgba(243, 244, 246, 0.6)',
                    '& td': {
                      color: '#4b5563',
                      borderBottom: '1px dashed rgba(200, 200, 200, 0.4)',
                      fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.8rem' },
                      py: { xs: 0.8, sm: 1, md: 1.2 },
                      px: { xs: 1, sm: 1.5, md: 2 },
                      fontWeight: 500,
                      whiteSpace: 'nowrap',
                    },
                  }}
                >
                  <TableCell sx={{ pl: { xs: 2, sm: 3, md: 4 } }}>
                    ↳ شعبه {branchStats.branch}
                  </TableCell>
                  <TableCell>
                    {Number(branchStats.bullion1g).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(branchStats.bullion2g).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(branchStats.bullion5g).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(branchStats.bullion10g).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(branchStats.bullion20g).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(branchStats.bullion50g).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(branchStats.bullion100g).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(
                      branchStats.bullion1g * 1 +
                        branchStats.bullion2g * 2 +
                        branchStats.bullion5g * 5 +
                        branchStats.bullion10g * 10 +
                        branchStats.bullion20g * 20 +
                        branchStats.bullion50g * 50 +
                        branchStats.bullion100g * 100
                    ).toLocaleString('fa-IR')}{' '}
                    گرم
                  </TableCell>
                </TableRow>
              ))}

              {/* --- ردیف بازخرید کل (تنها زمانی که تاریخ اختصاصی انتخاب نشده باشد نمایش داده می‌شود) --- */}
              {!isCustomDate && (
                <TableRow
                  sx={{
                    background: 'rgba(255, 255, 255, 0.9)',
                    transition: 'all 0.3s ease',
                    borderTop: '2px solid rgba(37, 99, 235, 0.2)',
                    '&:hover': {
                      background: 'rgba(254, 226, 226, 0.7)',
                    },
                    '& td': {
                      color: '#111827',
                      borderBottom: 'none',
                      fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.85rem' },
                      py: { xs: 1.2, sm: 1.5, md: 1.8 },
                      px: { xs: 1, sm: 1.5, md: 2 },
                      fontWeight: 700,
                      whiteSpace: { xs: 'nowrap', sm: 'nowrap', md: 'normal' },
                    },
                  }}
                >
                  <TableCell>بازخرید کل</TableCell>
                  <TableCell>
                    {Number(
                      buybackInfo?.details?.BULLION_1G || 0
                    ).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(
                      buybackInfo?.details?.BULLION_2G || 0
                    ).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(
                      buybackInfo?.details?.BULLION_5G || 0
                    ).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(
                      buybackInfo?.details?.BULLION_10G || 0
                    ).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(
                      buybackInfo?.details?.BULLION_20G || 0
                    ).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(
                      buybackInfo?.details?.BULLION_50G || 0
                    ).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell>
                    {Number(
                      buybackInfo?.details?.BULLION_100G || 0
                    ).toLocaleString('fa-IR')}
                  </TableCell>
                  <TableCell sx={{ color: '#e11d48 !important' }}>
                    {Number(
                      buybackInfo?.summary?.total_weight_grams || 0
                    ).toLocaleString('fa-IR')}{' '}
                    <Typography variant="caption" sx={{ fontWeight: 'normal' }}>
                      {' '}
                      گرم
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* مدال انتخاب تاریخ */}
      <SingleDayDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onConfirm={selectedDate => {
          setIsDialogOpen(false);
          fetchData(selectedDate);
        }}
      />
    </Grid>
  );
};

export default SalesAndBuyback;
